<template>
  <div>
    <mdb-tbl v-if="subjects.NCS && subjects.NCS.length" sm>
      <mdb-tbl-head>
        <tr>
          <th  class="bolder">과목</th>
          <th class="bolder" style="width:120px">수행</th>
          <th class="bolder" style="width:120px">필답</th>
          <th class="bolder" style="width:60px">태도</th>
          <th class="bolder" style="width:90px">포트폴리오</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body class="ml-3" v-for="(s, i) in subjects.NCS" :key="i">
        <tr><td class="bolder" colspan="5"><mdb-icon  icon="chalkboard-teacher" /> {{s.name}} ({{s.lectures.length}})</td></tr>
        <staff-student-test-score v-for="(l, i) in s.lectures" :key="i"
          :training="training._id" :student="student._id" :code="l.code" >
          <td class="pl-4 blue-text"><mdb-icon  icon="chalkboard"/> {{l.name}}</td>
        </staff-student-test-score>
      </mdb-tbl-body>
    </mdb-tbl>

    <mdb-tbl v-if="subjects && subjects.NONNCS && subjects.NONNCS.length" sm>
      <mdb-tbl-head>
        <tr><th colspan="5" class="title bolder my-3">비 NCS 교과</th></tr>
      </mdb-tbl-head>
      <mdb-tbl-head>
        <tr>
          <th  class="bolder">과목</th>
          <th class="bolder" style="width:120px">수행</th>
          <th class="bolder" style="width:120px">필답</th>
          <th class="bolder" style="width:60px">태도</th>
          <th class="bolder" style="width:90px">포트폴리오</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <staff-student-test-score v-for="(s, i) in subjects.NONNCS" :key="i"
          :training="training._id" :student="student._id" :code="s.name">
          <td class="indigo-text bolder"><mdb-icon  icon="chalkboard-teacher"/> {{s.name}}</td>
        </staff-student-test-score>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTabs, mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import StaffStudentTestScore from './StaffStudentTestScore.vue'
export default {
  name: 'StaffTestByStudent',
  components: { StaffStudentTestScore, mdbTbl, mdbTblHead, mdbTblBody },
  props: ['student'],
  data: () => ({
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training', 'subjects']),
    ...mapGetters('auth', ['isStaff', 'isTeacher'])
  },
  methods: {
    async load () {
      // 초기화 - student 변경시 해당 학생의 성적 목록 추출
    }
  },
  watch: { student: 'load' },
  created () { this.load() }
}
</script>
